import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';

import App from './App.tsx';
import { store, persistor } from './store';
import { BrowserRouter } from 'react-router-dom';

import { PersistGate } from 'redux-persist/integration/react';
import 'typeface-montserrat';
import 'typeface-poppins';
import { appMode } from './utils/url.ts';
import InjectScript from './Script.tsx';

if (
  import.meta.env.MODE === 'production' ||
  import.meta.env.VITE_APP_MODE === 'production' ||
  appMode === 'production'
) {
  console.log = () => {};
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <Provider {...{ store }}>
    <BrowserRouter>
      <PersistGate loading={null} persistor={persistor}>
        <App />
        <InjectScript />
      </PersistGate>
    </BrowserRouter>
  </Provider>,
);
